/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var LocationMapIcon24Solid = forwardRef('LocationMapIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "m14.625 5.397-5.25-2.443V18.61l5.25 2.442V5.397Z" }),
        React.createElement("path", { d: "m16.375 20.566 4.276-2.086a1.5 1.5 0 0 0 .842-1.349V4.001a1 1 0 0 0-1.438-.9l-3.68 1.796v15.669Z" }),
        React.createElement("path", { d: "m3.338 5.52 4.287-2.09v15.668l-3.69 1.8A1 1 0 0 1 2.494 20V6.869a1.5 1.5 0 0 1 .843-1.348Z" })));
});
